import React, { useEffect } from 'react';
import Box from 'core/ui/Box';
import { useTranslation } from 'react-i18next';
import ChoosenChannelTags from 'core/ui/ChoosenChannelTags';
import SelectBoxSearch from 'core/ui/SelectBox/SelectBoxSearch';
import { membersTypes } from 'core/utils/consts';
import SelectorChannelUser from 'components/Channel/SelectorChannelUser';
import Toggle from 'core/ui/Toggle';
import { Tooltip } from '@material-ui/core';
import { Info } from '@material-ui/icons';

const FiltersMembers = ({ index, channelId, values, onChangeFiltersValues }) => {
  const { t } = useTranslation();

  const onSelectCustomUsers = (user) => {
    const users = values?.filtersCustomUsers || [];

    onChangeFiltersValues(index, {
      filtersCustomUsers: [...users, { id: user?.id, name: user?.name }],
    });
  };

  useEffect(() => {
    if (!values?.classRegistration) {
      onChangeFiltersValues(index, {
        classRegistration: 'registered',
      });
    }
  }, []);

  return (
    <>
      {['member_tags', 'memberships_tags'].find((x) => x === values?.filterType) && (
        <Box flex={1}>
          <ChoosenChannelTags
            placeholder={t('channel.tags')}
            val={values?.filterTags ? [...(values.filterTags || [])] : []}
            setValue={(v) =>
              onChangeFiltersValues(index, { filterTags: normalizeChoosenChannelTagsValue(v) })
            }
            channelId={channelId}
            bordered
          />
        </Box>
      )}

      {values?.filterType === 'member_types' && (
        <Box flex={1}>
          <SelectBoxSearch
            options={membersTypes.map((x) => ({
              id: x,
              name: t(`channel.memberships.column.type.${x}`),
            }))}
            getOptionLabel={(v) => v?.name}
            value={
              values?.memberTypes?.map((x) => ({
                id: x,
                name: t(`channel.memberships.column.type.${x}`),
              })) || []
            }
            setValue={(v) => onChangeFiltersValues(index, { memberTypes: v?.map((x) => x.id) })}
            required
            multiple
            bordered
          />
        </Box>
      )}

      {values?.filterType === 'custom_users' && (
        <Box flex={1}>
          <SelectorChannelUser
            onSelectedUser={(u) => onSelectCustomUsers(u)}
            channelId={channelId}
            showCreateButton={false}
          />
        </Box>
      )}

      {values?.filterType === 'class_registration' && (
        <Box flex={1}>
          <div>
            <Toggle
              options={[
                {
                  value: 'registered',
                  label: (
                    <div className="tw-flex tw-flex-row tw-items-center tw-gap-2">
                      <div>{t('label.registered')}</div>
                      <Tooltip title={t('label.registered.help')}>
                        <Info style={{ fontSize: 12 }} />
                      </Tooltip>
                    </div>
                  ),
                  width: 120,
                },
                {
                  value: 'not_registered',
                  label: (
                    <div className="tw-flex tw-flex-row tw-items-center tw-gap-2">
                      <div>{t('label.notRegistered')}</div>
                      <Tooltip title={t('label.notRegistered.help')}>
                        <Info style={{ fontSize: 12 }} />
                      </Tooltip>
                    </div>
                  ),
                  width: 120,
                },
              ]}
              value={values?.classRegistration}
              onChange={(v) => {
                onChangeFiltersValues(index, { classRegistration: v });
              }}
            />
          </div>
        </Box>
      )}
    </>
  );
};

const normalizeChoosenChannelTagsValue = (values = []) =>
  values
    .map((value) => {
      const typeOfValue = typeof value;

      if (typeOfValue === 'string') {
        return value;
      }

      if (typeOfValue === 'object' && value.name) {
        return value.name;
      }

      return undefined;
    })
    .filter((value) => value);

export default FiltersMembers;
